<template>
  <div>
    <a-select
      v-model='propsModel.value'
      :placeholder='propsModel.placeholder'
      :size='propsModel.size'
      @change='handleChange'
      style='width: 100%;'>
      <a-select-option
        v-for='item in dictOptions'
        :value='item.itemValue'>
        {{ item[fieldKey] }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
import dict from './dict-mixin-extend'

export default {
  mixins: [dict],
  props: {
    dictCode: {
      type: String,
      default: undefined
    },
    value: {
      type: [String, Number],
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    begin: {
      type: Array,
      default: () => []
    },
    end: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    propsModel() {
      return { ...this.$props }
    },
    dictOptions() {
      const { dictCode } = this
      console.log('dictCode-------->', dictCode)
      //dictCode--------> orderstatus
      console.log('this.begin', this.begin)
      console.log('this.end', this.end)
      const list = [...this.transformList(this.begin), ...this.getDictList(dictCode), ...this.transformList(this.end)]
      console.log('list---->>>>>>>>>>>>>>>>>', list)
      return list
    }
  },
  methods: {
    transformList(list) {
      console.log('transformList拿到的list是什么？', list)
      list.forEach(item => {
        item.itemValue = item.value
        item.itemTextEn = item.labelEn
        item.itemText = item.label
        item.itemTextTha = item.labelTi
      })
      // console.log('transformList处理后的list是什么？', list)
      return list
    },
    handleChange(val) {
      // console.log('切换了审核状态val-->',val)
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>
<style lang='less' scoped>

</style>
